const breakpoints = {
    sm: "320px",
    md: "768px",
    lg: "1280px",
    xl: "1440px",
    "2xl": "1920px",
};
export default breakpoints;
//# sourceMappingURL=breakpoints.js.map